(() => {
  'use strict';
  const bar = document.getElementById('country-currency-display');
  if (!bar || bar.dataset.ready) return;
  bar.dataset.ready = 'true';
  
  const status = document.getElementById('country-currency-status');
  const day = 86400000;
  const choiceKey = '454-display-currency-v1';
  const groups = {
    USD: 'US AS BQ EC FM GU IO MH MP PA PR PW SV TC TL UM VG VI',
    EUR: 'AD AT AX BE BG BL CY DE EE ES FI FR GF GP GR HR IE IT LT LU LV MC ME MF MQ MT NL PM PT RE SI SK SM TF VA XK YT',
    GBP: 'GB GG IM JE', AUD: 'AU CC CX HM KI NF NR TV', NZD: 'NZ CK NU PN TK',
    XOF: 'BF BJ CI GW ML NE SN TG', XAF: 'CF CG CM GA GQ TD', XCD: 'AG AI DM GD KN LC MS VC',
    XPF: 'NC PF WF', CHF: 'CH LI', DKK: 'DK FO GL', NOK: 'NO BV SJ', ILS: 'IL PS',
    ZAR: 'ZA', AED: 'AE', AFN: 'AF', ALL: 'AL', AMD: 'AM', AOA: 'AO', ARS: 'AR', AWG: 'AW', AZN: 'AZ',
    BAM: 'BA', BBD: 'BB', BDT: 'BD', BHD: 'BH', BIF: 'BI', BMD: 'BM', BND: 'BN', BOB: 'BO', BRL: 'BR',
    BSD: 'BS', BTN: 'BT', BWP: 'BW', BYN: 'BY', BZD: 'BZ', CAD: 'CA', CDF: 'CD', CLP: 'CL', CNY: 'CN',
    COP: 'CO', CRC: 'CR', CUP: 'CU', CVE: 'CV', CZK: 'CZ', DJF: 'DJ', DOP: 'DO', DZD: 'DZ', EGP: 'EG',
    ERN: 'ER', ETB: 'ET', FJD: 'FJ', FKP: 'FK', GEL: 'GE', GHS: 'GH', GIP: 'GI', GMD: 'GM', GNF: 'GN',
    GTQ: 'GT', GYD: 'GY', HKD: 'HK', HNL: 'HN', HTG: 'HT', HUF: 'HU', IDR: 'ID', INR: 'IN', IQD: 'IQ',
    IRR: 'IR', ISK: 'IS', JMD: 'JM', JOD: 'JO', JPY: 'JP', KES: 'KE', KGS: 'KG', KHR: 'KH', KMF: 'KM',
    KPW: 'KP', KRW: 'KR', KWD: 'KW', KYD: 'KY', KZT: 'KZ', LAK: 'LA', LBP: 'LB', LKR: 'LK', LRD: 'LR',
    LSL: 'LS', LYD: 'LY', MAD: 'MA EH', MDL: 'MD', MGA: 'MG', MKD: 'MK', MMK: 'MM', MNT: 'MN', MOP: 'MO',
    MRU: 'MR', MUR: 'MU', MVR: 'MV', MWK: 'MW', MXN: 'MX', MYR: 'MY', MZN: 'MZ', NAD: 'NA', NGN: 'NG',
    NIO: 'NI', NPR: 'NP', OMR: 'OM', PEN: 'PE', PGK: 'PG', PHP: 'PH', PKR: 'PK', PLN: 'PL', PYG: 'PY',
    QAR: 'QA', RON: 'RO', RSD: 'RS', RUB: 'RU', RWF: 'RW', SAR: 'SA', SBD: 'SB', SCR: 'SC', SDG: 'SD',
    SEK: 'SE', SGD: 'SG', SHP: 'SH', SLE: 'SL', SOS: 'SO', SRD: 'SR', SSP: 'SS', STN: 'ST', SYP: 'SY',
    SZL: 'SZ', THB: 'TH', TJS: 'TJ', TMT: 'TM', TND: 'TN', TOP: 'TO', TRY: 'TR', TTD: 'TT', TWD: 'TW',
    TZS: 'TZ', UAH: 'UA', UGX: 'UG', UYU: 'UY', UZS: 'UZ', VES: 'VE', VND: 'VN', VUV: 'VU', WST: 'WS',
    XCG: 'CW SX', YER: 'YE', ZMW: 'ZM', ZWG: 'ZW'
  };
  const countries = Object.fromEntries(Object.entries(groups).flatMap(([currency, codes]) => codes.split(' ').map(code => [code, currency])));
  const currencies = Object.keys(groups).sort();
  const priceSelector = [
    '.k454-unit-price', '.k454-line-total', '.k454-summary dd', '.k454-mobile-bar strong', '.bu454-prices strong', '.bu454-prices span', '.bu454-delta', '.f454-prices', '.f454-unit-price', '.f454-sticky strong', '.c454-price', '.c454-card-price', '.c454-compare-price', '[data-current-price]', '[data-unit-money]', '.fh-price', '.fh-product-price', '.money', '.price-item', '.cart-item__price-wrapper', '.cart-item__totals', '.totals__total-value',
    '.discounts__discount', '.cart-notification-product__price', '.price-per-item', '.volume-pricing',
    '.ecom-product-single__price--prices', '.ecom-product-upsell__price', '.ecom-collection__product-price-wrapper',
    '.ecom-cart__product-prices', '.ecom-cart__product-item__totals', '.ecom-cart__product-discounts',
    '.ecom-ajax-cart-line-item-prices', '.ecom-ajax-cart-line-item-cart-item-totals', '.ecom-ajax-cart-line-item-unit-price',
    '.ecom-ajax-cart-totals__subtotal', '.ecom-discounts__discount', '.ecom-free-shipping-bar__text',
    '[data-hulkapps-cart-total]', '[data-hulkapps-total-price]', '[data-hulkapps-line-price]', '[data-hulkapps-price]'
  ].join(',');
  const excluded = 'script,style,template,noscript,input,textarea,select,iframe,[contenteditable="true"],#country-currency-display,[data-454-currency-ignore],.facets,.facets-container,.ecom-collection__filters-group';
  const usdPattern = /(?:US\s*\$|\$|USD\s+)(\d{1,3}(?:,\d{3})+(?:\.\d{1,2})?|\d+(?:\.\d{1,2})?)(?:\s*USD\b)?/g;
  let currency = 'USD';
  let rate = 1;
  let detectedCountry = bar.dataset.country || null;
  let revision = 0;
  let queued = false;
  let observer;
  const preferred = 'auto';
  const locale = document.documentElement.lang || 'en';
  function read(key) { try { return localStorage.getItem(key); } catch { return null; } }
  function save(key, value) { try { localStorage.setItem(key, value); } catch {} }
  async function json(url, options = {}) {
    const response = await fetch(url, { ...options, signal: AbortSignal.timeout(7000) });
    if (!response.ok) throw new Error('Unavailable');
    return response.json();
  }
  function usable(data, code) {
    const age = Date.now() - Date.parse(data?.date);
    return data?.base === 'USD' && data?.quote === code && Number.isFinite(data?.rate) && data.rate > 0 && age >= -day && age <= 7 * day;
  }
  async function exchange(code) {
    const key = `454-fx-v1-${code}`;
    let cached;
    try { cached = JSON.parse(read(key)); } catch {}
    if (usable(cached, code) && Date.now() - cached.saved < day && cached.saved <= Date.now()) return cached;
    try {
      const data = await json(`https://api.frankfurter.dev/v2/rate/usd/${code.toLowerCase()}`, { credentials: 'omit', referrerPolicy: 'no-referrer' });
      if (!usable(data, code)) throw new Error('Invalid rate');
      const record = { base: 'USD', quote: code, rate: data.rate, date: data.date, saved: Date.now() };
      save(key, JSON.stringify(record));
      return record;
    } catch (error) {
      if (usable(cached, code)) return cached;
      throw error;
    }
  }
  function format(cents) {
    return new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100 * rate);
  }
  function tokenText(token) {
    return currency === 'USD' ? token.dataset.raw : `≈ ${format(Number(token.dataset['454Usd']))}${new Intl.NumberFormat(locale, {style: 'currency', currency: 'USD', currencyDisplay: 'code'}).format(Number(token.dataset['454Usd']) / 100)}`;
  }
  function updateToken(token) {
    if (!token.dataset.raw || !Number.isFinite(Number(token.dataset['454Usd']))) return;
    if (currency === 'USD') {
      if (token.textContent !== token.dataset.raw) token.textContent = token.dataset.raw;
      token.removeAttribute('title');
      return;
    }
    if (token.textContent === tokenText(token)) return;
    const estimate = document.createElement('span');
    estimate.className = 'currency-estimate';
    estimate.textContent = `≈ ${format(Number(token.dataset['454Usd']))}`;
    const original = document.createElement('small');
    original.className = 'currency-usd-original';
    original.textContent = new Intl.NumberFormat(locale, {style: 'currency', currency: 'USD', currencyDisplay: 'code'}).format(Number(token.dataset['454Usd']) / 100);
    token.replaceChildren(estimate, original);
    token.title = bar.dataset.checkoutMessage;
  }
  function tokenize(node) {
    const text = node.nodeValue;
    usdPattern.lastIndex = 0;
    const matches = [...text.matchAll(usdPattern)];
    if (!matches.length) return;
    const fragment = document.createDocumentFragment();
    let offset = 0;
    for (const match of matches) {
      const preceding = text[match.index - 1];
      if (preceding && /[A-Z]/i.test(preceding)) continue;
      const cents = Math.round(Number(match[1].replaceAll(',', '')) * 100);
      if (!Number.isSafeInteger(cents)) continue;
      fragment.append(text.slice(offset, match.index));
      const token = document.createElement('span');
      token.dataset['454Usd'] = String(cents);
      token.dataset.raw = match[0];
      updateToken(token);
      fragment.append(token);
      offset = match.index + match[0].length;
    }
    if (!offset) return;
    fragment.append(text.slice(offset));
    node.replaceWith(fragment);
  }
  function render() {
    queued = false;
    observer?.disconnect();
    document.querySelectorAll('[data-454-usd]').forEach(updateToken);
    const handled = new WeakSet();
    document.querySelectorAll(priceSelector).forEach(root => {
      if (root.closest(excluded) || root.closest('[data-454-usd]')) return;
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          return handled.has(node) || node.parentElement.closest(`${excluded},[data-454-usd]`) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
        }
      });
      const nodes = [];
      while (walker.nextNode()) { nodes.push(walker.currentNode); handled.add(walker.currentNode); }
      nodes.forEach(tokenize);
    });
    document.querySelectorAll('.k454-checkout,.cart__ctas,.ecom-cart__checkout-button-container,.ecom-ajax-cart-totals,.cart-notification__links').forEach(root => {
      let notice = root.previousElementSibling;
      if (!notice?.classList.contains('country-currency-checkout-notice')) notice = null;
      if (!notice) { notice = document.createElement('p'); notice.className = 'country-currency-checkout-notice'; root.before(notice); }
      notice.textContent = currency === 'USD' ? '' : bar.dataset.checkoutMessage;
      notice.hidden = currency === 'USD';
    });
    observer?.observe(document.body, { subtree: true, childList: true, characterData: true });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(render); } }
  observer = new MutationObserver(records => {
    let relevant = false;
    for (const record of records) {
      const element = record.target.nodeType === Node.TEXT_NODE ? record.target.parentElement : record.target;
      if (!element || element.closest('#country-currency-display')) continue;
      const token = element.closest('[data-454-usd]');
      if (token) {
        const expected = tokenText(token);
        if (token.textContent !== expected) {
          token.removeAttribute('data-454-usd'); token.removeAttribute('data-raw'); token.removeAttribute('title');
        }
      }
      if (token || element.closest(priceSelector) || record.addedNodes.length) relevant = true;
    }
    if (relevant) schedule();
  });
  async function choose() {
    const turn = ++revision;
    const code = preferred === 'auto' ? countries[detectedCountry] || 'USD' : preferred;
    status.hidden = code === 'USD';
    if (code === 'USD') {
      currency = 'USD'; rate = 1; status.textContent = bar.dataset.usdMessage; render(); return;
    }
    try {
      const data = await exchange(code);
      if (turn !== revision) return;
      currency = code; rate = data.rate;
      status.textContent = `${bar.dataset.estimateMessage} ${bar.dataset.rateLabel} ${new Intl.DateTimeFormat(locale, {dateStyle: 'medium', timeZone: 'UTC'}).format(new Date(data.date))}.`;
    } catch {
      if (turn !== revision) return;
      currency = 'USD'; rate = 1;
      status.textContent = bar.dataset.errorMessage;
    }
    render();
  }
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') choose(); });
  render();
  choose();
  {
    json(`${window.Shopify?.routes?.root || '/'}browsing_context_suggestions.json?country[enabled]=true`, { credentials: 'same-origin' })
      .then(data => {
        const country = data?.detected_values?.country?.handle;
        if (bar.dataset.country === 'US' && !bar.dataset.regional && /^[A-Z]{2}$/.test(country)) detectedCountry = country;
        if (preferred === 'auto') choose();
      }).catch(() => {});
  }
})();
